import {
  ADMINS_FETCHING,
  ADMINS_FAILED,
  ADMINS_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ADMINS_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ADMINS_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ADMINS_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
